// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Header2_header__xy5yU {
  padding: 5rem;
  box-sizing: border-box;
}
@media only screen and (max-width: 62.5em) {
  .Header2_header__xy5yU {
    padding: 5rem 5rem;
  }
}
.Header2_header__nav__MbCLJ {
  display: flex;
  justify-content: space-evenly;
  align-items: center;
}
@media only screen and (max-width: 62.5em) {
  .Header2_header__nav__MbCLJ {
    justify-content: space-between;
  }
}
.Header2_header__nav__btn__wRKfY {
  display: flex;
  gap: 2.3rem;
}
@media only screen and (max-width: 62.5em) {
  .Header2_header__nav__btn__wRKfY {
    display: none;
  }
}
.Header2_header__nav_icon__0ZP2y {
  display: none;
  cursor: pointer;
}
@media only screen and (max-width: 62.5em) {
  .Header2_header__nav_icon__0ZP2y {
    display: block;
    font-size: 5rem;
  }
  .Header2_header__nav_icon__0ZP2y:hover {
    color: var(--color-primary);
  }
}

.Header2_logo__1Z9bI {
  width: 18rem;
  height: 100%;
}

.Header2_nav__item__VI-GO {
  display: flex;
  list-style: none;
}
.Header2_nav__item__list__9EpCH {
  text-decoration: none;
  color: var(--color-dark);
  cursor: pointer;
}
.Header2_nav__item__list__9EpCH:hover, .Header2_nav__item__list__9EpCH:active {
  font-weight: 700;
  color: var(--color-primary);
}
.Header2_nav__item__list__9EpCH:not(:last-child) {
  margin-right: 2.5rem;
}
.Header2_nav__item__link__VMrGQ:link, .Header2_nav__item__link__VMrGQ:visited {
  text-decoration: none;
  color: var(--color-dark);
  cursor: pointer;
}
.Header2_nav__item__link__VMrGQ:link:hover, .Header2_nav__item__link__VMrGQ:link:active, .Header2_nav__item__link__VMrGQ:visited:hover, .Header2_nav__item__link__VMrGQ:visited:active {
  font-weight: 700;
  color: var(--color-primary);
}
@media only screen and (max-width: 62.5em) {
  .Header2_nav__item__VI-GO {
    display: none;
  }
}

.Header2_btn__icon__PodMi {
  height: 2.2rem;
  margin-right: 1rem;
}

.Header2_slide__n4pKp {
  margin-top: 10rem;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  justify-content: center;
  box-sizing: border-box;
  gap: 3rem;
}
@media only screen and (max-width: 62.5em) {
  .Header2_slide__n4pKp {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 3rem;
    margin-top: 4rem;
  }
}
.Header2_slide__text__4jEBl {
  display: flex;
  flex-direction: column;
  justify-content: center;
  max-width: 65rem;
  padding-right: 2rem;
}
@media only screen and (max-width: 62.5em) {
  .Header2_slide__text__4jEBl {
    text-align: center;
  }
}
.Header2_slide__text_btn__tOs9t {
  display: flex;
  justify-content: left;
  margin-top: 2rem;
}
@media only screen and (max-width: 62.5em) {
  .Header2_slide__text_btn__tOs9t {
    justify-content: center;
  }
}
@media only screen and (max-width: 37.5em) {
  .Header2_slide__text_btn__tOs9t {
    flex-direction: column;
    align-items: center;
  }
}
.Header2_slide__img__ibo-v {
  width: 100%;
  height: auto;
  object-fit: cover;
  border-radius: 4rem;
}

.Header2_menu__Nqr1T {
  width: 100vw;
  height: 100vh;
  background-color: var(--color-light);
  position: fixed;
  padding: 5rem 10rem;
  overflow-y: scroll;
  z-index: 100;
}
@media only screen and (max-width: 37.5em) {
  .Header2_menu__Nqr1T {
    padding: 5rem 5rem;
  }
}
.Header2_menu__logo__oGZ9x {
  width: 18rem;
}
.Header2_menu__top__OjxAF {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;
}
.Header2_menu__icon__ZmZUk {
  font-size: 5rem;
  color: var(--color-primary);
  cursor: pointer;
}
.Header2_menu__nav__gIdMu {
  height: 50vh;
  display: flex;
  flex-direction: column;
  font-size: var(--default-font-subtitle);
  text-align: center;
  justify-content: space-evenly;
  margin-bottom: 2rem;
}
.Header2_menu__nav__item__xxWVl {
  list-style: none;
}
.Header2_menu__nav__link__dxXvg {
  cursor: pointer;
  text-decoration: none;
  color: var(--color-dark);
}
.Header2_menu__nav__link__dxXvg:hover, .Header2_menu__nav__link__dxXvg:focus {
  font-weight: 700;
  color: var(--color-primary);
}
.Header2_menu__nav__btn__m8wm5 {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.Header2_main__RSxj7 {
  position: relative;
}

.Header2_modal__bckjJ {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
}
.Header2_modal__bckjJ img {
  height: 27rem;
  border-radius: 3rem;
  margin: 2rem 0;
}

.Header2_businesses__\\+nB91 {
  margin-top: 4rem;
  text-align: center;
}
@media only screen and (max-width: 62.5em) {
  .Header2_businesses__title__KZU\\+J {
    font-size: var(--default-font-h3);
  }
}
.Header2_businesses__list__xBkru {
  display: flex;
  justify-content: space-between;
  margin-right: 2rem;
  color: var(--color-grey);
}
.Header2_businesses__img__V8uIQ {
  height: 5rem;
  width: 10rem;
  object-fit: cover;
  border-radius: 1rem;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/LandingPage/Header2.module.scss"],"names":[],"mappings":"AAEA;EACC,aAAA;EACA,sBAAA;AADD;AAGC;EAJD;IAKE,kBAAA;EAAA;AACF;AAEC;EACC,aAAA;EACA,6BAAA;EACA,mBAAA;AAAF;AAEE;EALD;IAME,8BAAA;EACD;AACF;AAAE;EACC,aAAA;EACA,WAAA;AAEH;AADG;EAHD;IAIE,aAAA;EAIF;AACF;AAFE;EACC,aAAA;EACA,eAAA;AAIH;AAHG;EAHD;IAIE,cAAA;IACA,eAAA;EAMF;EALE;IACC,2BAAA;EAOH;AACF;;AAFA;EACC,YAAA;EACA,YAAA;AAKD;;AAFC;EACC,aAAA;EACA,gBAAA;AAKF;AAJE;EACC,qBAAA;EACA,wBAAA;EACA,eAAA;AAMH;AALG;EAEC,gBAAA;EACA,2BAAA;AAMJ;AAJG;EACC,oBAAA;AAMJ;AAHE;EAEC,qBAAA;EACA,wBAAA;EACA,eAAA;AAIH;AAHG;EAEC,gBAAA;EACA,2BAAA;AAIJ;AAAE;EA5BD;IA6BE,aAAA;EAGD;AACF;;AAIC;EACC,cAAA;EACA,kBAAA;AADF;;AAMA;EACC,iBAAA;EACA,aAAA;EACA,qCAAA;EACA,uBAAA;EACA,sBAAA;EACA,SAAA;AAHD;AAKC;EARD;IASE,aAAA;IACA,sBAAA;IACA,mBAAA;IACA,SAAA;IACA,gBAAA;EAFA;AACF;AAIC;EACC,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;AAFF;AAIE;EAPD;IAQE,kBAAA;EADD;AACF;AAGE;EACC,aAAA;EACA,qBAAA;EACA,gBAAA;AADH;AAEG;EAJD;IAKE,uBAAA;EACF;AACF;AAAG;EAPD;IAQE,sBAAA;IACA,mBAAA;EAGF;AACF;AACC;EACC,WAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;AACF;;AAGA;EACC,YAAA;EACA,aAAA;EACA,oCAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;AAAD;AAEC;EATD;IAUE,kBAAA;EACA;AACF;AACC;EACC,YAAA;AACF;AAEC;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;AAAF;AAGC;EACC,eAAA;EACA,2BAAA;EACA,eAAA;AADF;AAIC;EACC,YAAA;EACA,aAAA;EACA,sBAAA;EACA,uCAAA;EACA,kBAAA;EACA,6BAAA;EACA,mBAAA;AAFF;AAIE;EACC,gBAAA;AAFH;AAKE;EACC,eAAA;EACA,qBAAA;EACA,wBAAA;AAHH;AAKG;EAEC,gBAAA;EACA,2BAAA;AAJJ;AAQE;EACC,aAAA;EACA,sBAAA;EACA,mBAAA;AANH;;AAWA;EACC,kBAAA;AARD;;AAWA;EACC,kBAAA;EACA,OAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;AARD;AAUC;EACC,aAAA;EACA,mBAAA;EACA,cAAA;AARF;;AAWA;EACC,gBAAA;EACA,kBAAA;AARD;AAYE;EAFD;IAGE,iCAAA;EATD;AACF;AAYC;EACC,aAAA;EACA,8BAAA;EACA,kBAAA;EACA,wBAAA;AAVF;AAaC;EACC,YAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;AAXF","sourcesContent":["@import '../variables/breakpoints';\n\n.header {\n\tpadding: 5rem;\n\tbox-sizing: border-box;\n\n\t@media only screen and (max-width: $bp-large) {\n\t\tpadding: 5rem 5rem;\n\t}\n\n\t&__nav {\n\t\tdisplay: flex;\n\t\tjustify-content: space-evenly;\n\t\talign-items: center;\n\n\t\t@media only screen and (max-width: $bp-large) {\n\t\t\tjustify-content: space-between;\n\t\t}\n\t\t&__btn {\n\t\t\tdisplay: flex;\n\t\t\tgap: 2.3rem;\n\t\t\t@media only screen and (max-width: $bp-large) {\n\t\t\t\tdisplay: none;\n\t\t\t}\n\t\t}\n\t\t&_icon {\n\t\t\tdisplay: none;\n\t\t\tcursor: pointer;\n\t\t\t@media only screen and (max-width: $bp-large) {\n\t\t\t\tdisplay: block;\n\t\t\t\tfont-size: 5rem;\n\t\t\t\t&:hover {\n\t\t\t\t\tcolor: var(--color-primary);\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n.logo {\n\twidth: 18rem;\n\theight: 100%;\n}\n.nav {\n\t&__item {\n\t\tdisplay: flex;\n\t\tlist-style: none;\n\t\t&__list {\n\t\t\ttext-decoration: none;\n\t\t\tcolor: var(--color-dark);\n\t\t\tcursor: pointer;\n\t\t\t&:hover,\n\t\t\t&:active {\n\t\t\t\tfont-weight: 700;\n\t\t\t\tcolor: var(--color-primary);\n\t\t\t}\n\t\t\t&:not(:last-child) {\n\t\t\t\tmargin-right: 2.5rem;\n\t\t\t}\n\t\t}\n\t\t&__link:link,\n\t\t&__link:visited {\n\t\t\ttext-decoration: none;\n\t\t\tcolor: var(--color-dark);\n\t\t\tcursor: pointer;\n\t\t\t&:hover,\n\t\t\t&:active {\n\t\t\t\tfont-weight: 700;\n\t\t\t\tcolor: var(--color-primary);\n\t\t\t}\n\t\t}\n\n\t\t@media only screen and (max-width: $bp-large) {\n\t\t\tdisplay: none;\n\t\t}\n\t}\n}\n\n// button style\n\n.btn {\n\t&__icon {\n\t\theight: 2.2rem;\n\t\tmargin-right: 1rem;\n\t}\n}\n\n//Slide section\n.slide {\n\tmargin-top: 10rem;\n\tdisplay: grid;\n\tgrid-template-columns: repeat(2, 1fr);\n\tjustify-content: center;\n\tbox-sizing: border-box;\n\tgap: 3rem;\n\n\t@media only screen and (max-width: $bp-large) {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\talign-items: center;\n\t\tgap: 3rem;\n\t\tmargin-top: 4rem;\n\t}\n\n\t&__text {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tjustify-content: center;\n\t\tmax-width: 65rem;\n\t\tpadding-right: 2rem;\n\n\t\t@media only screen and (max-width: $bp-large) {\n\t\t\ttext-align: center;\n\t\t}\n\n\t\t&_btn {\n\t\t\tdisplay: flex;\n\t\t\tjustify-content: left;\n\t\t\tmargin-top: 2rem;\t\t\t\n\t\t\t@media only screen and (max-width: $bp-large) {\n\t\t\t\tjustify-content: center;\n\t\t\t}\n\t\t\t@media only screen and (max-width: $bp-small) {\n\t\t\t\tflex-direction: column;\n\t\t\t\talign-items: center;\n\t\t\t}\n\t\t}\n\t}\n\n\t&__img {\t\t\n\t\twidth: 100%;\n\t\theight: auto;\n\t\tobject-fit: cover;\n\t\tborder-radius: 4rem;\t\n\t}\n}\n\n.menu {\n\twidth: 100vw;\n\theight: 100vh;\n\tbackground-color: var(--color-light);\n\tposition: fixed;\n\tpadding: 5rem 10rem;\n\toverflow-y: scroll;\n\tz-index: 100;\n\n\t@media only screen and (max-width: $bp-small) {\n\t\tpadding: 5rem 5rem;\n\t}\n\n\t&__logo {\n\t\twidth: 18rem;\n\t}\n\n\t&__top {\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\talign-items: center;\n\t\tmargin-bottom: 2rem;\n\t}\n\n\t&__icon {\n\t\tfont-size: 5rem;\n\t\tcolor: var(--color-primary);\n\t\tcursor: pointer;\n\t}\n\n\t&__nav {\n\t\theight: 50vh;\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tfont-size: var(--default-font-subtitle);\n\t\ttext-align: center;\n\t\tjustify-content: space-evenly;\n\t\tmargin-bottom: 2rem;\n\n\t\t&__item {\n\t\t\tlist-style: none;\n\t\t}\n\n\t\t&__link {\n\t\t\tcursor: pointer;\n\t\t\ttext-decoration: none;\n\t\t\tcolor: var(--color-dark);\n\n\t\t\t&:hover,\n\t\t\t&:focus {\n\t\t\t\tfont-weight: 700;\n\t\t\t\tcolor: var(--color-primary);\n\t\t\t}\n\t\t}\n\n\t\t&__btn {\n\t\t\tdisplay: flex;\n\t\t\tflex-direction: column;\n\t\t\talign-items: center;\n\t\t}\n\t}\n}\n\n.main {\n\tposition: relative;\n}\n\n.modal {\n\tposition: absolute;\n\tleft: 0;\n\ttop: 0;\n\tright: 0;\n\tbottom: 0;\n\n\timg {\n\t\theight: 27rem;\n\t\tborder-radius: 3rem;\n\t\tmargin: 2rem 0;\n\t}\n}\n.businesses {\n\tmargin-top: 4rem;\t\n\ttext-align: center;\n\t\n\t&__title {\n\t\t\n\t\t@media only screen and (max-width: $bp-large) {\n\t\t\tfont-size: var(--default-font-h3);\t\t\t\n\t\t}\n\t}\n\n\t&__list{\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\tmargin-right: 2rem;\n\t\tcolor: var(--color-grey);\t\n\t}\n\n\t&__img {\n\t\theight: 5rem;\n\t\twidth: 10rem; \n\t\tobject-fit: cover;\n\t\tborder-radius: 1rem;\n\t\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `Header2_header__xy5yU`,
	"header__nav": `Header2_header__nav__MbCLJ`,
	"header__nav__btn": `Header2_header__nav__btn__wRKfY`,
	"header__nav_icon": `Header2_header__nav_icon__0ZP2y`,
	"logo": `Header2_logo__1Z9bI`,
	"nav__item": `Header2_nav__item__VI-GO`,
	"nav__item__list": `Header2_nav__item__list__9EpCH`,
	"nav__item__link": `Header2_nav__item__link__VMrGQ`,
	"btn__icon": `Header2_btn__icon__PodMi`,
	"slide": `Header2_slide__n4pKp`,
	"slide__text": `Header2_slide__text__4jEBl`,
	"slide__text_btn": `Header2_slide__text_btn__tOs9t`,
	"slide__img": `Header2_slide__img__ibo-v`,
	"menu": `Header2_menu__Nqr1T`,
	"menu__logo": `Header2_menu__logo__oGZ9x`,
	"menu__top": `Header2_menu__top__OjxAF`,
	"menu__icon": `Header2_menu__icon__ZmZUk`,
	"menu__nav": `Header2_menu__nav__gIdMu`,
	"menu__nav__item": `Header2_menu__nav__item__xxWVl`,
	"menu__nav__link": `Header2_menu__nav__link__dxXvg`,
	"menu__nav__btn": `Header2_menu__nav__btn__m8wm5`,
	"main": `Header2_main__RSxj7`,
	"modal": `Header2_modal__bckjJ`,
	"businesses": `Header2_businesses__+nB91`,
	"businesses__title": `Header2_businesses__title__KZU+J`,
	"businesses__list": `Header2_businesses__list__xBkru`,
	"businesses__img": `Header2_businesses__img__V8uIQ`
};
export default ___CSS_LOADER_EXPORT___;
